import { render, staticRenderFns } from "./SamplesStatement.vue?vue&type=template&id=de8a27a6"
import script from "./SamplesStatement.vue?vue&type=script&lang=js"
export * from "./SamplesStatement.vue?vue&type=script&lang=js"
import style0 from "./SamplesStatement.vue?vue&type=style&index=0&id=de8a27a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports